export default __webpack_public_path__ + "static/media/about.12a3c224.svg";